import React, { lazy } from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import ContainerPage from "../page/Container/Container.jsx";
import NotFound from "../page/NotFound/NotFound.jsx";
import PermissionDenied from "../page/PermissionDenied/index.jsx";
import SignInSide from "../page/Login/Login.jsx";
import { PrivateRoute } from "./PrivateRoute.jsx";
import PublicRoute from "./PublicRoute.jsx";
import Loadable from "../page/Container/Loadable.jsx";

const Dashboard = Loadable(lazy(() => import('../page/Dashboard/Dashboard')));
const Medicine = Loadable(lazy(() => import('../page/Obat/Medicine')));
const RequestMedicine = Loadable(lazy(() => import('../page/RequestObat/RequestObat')));
const Swab = Loadable(lazy(() => import('../page/Swab/Swab')));
const RekamMedis = Loadable(lazy(() => import('../page/RekamMedis/RekamMedis')));
const BodyComposition = Loadable(lazy(() => import('../page/BodyComposition')));

export default function Routers() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<PublicRoute component={SignInSide} />} />
        <Route
          path="/"
          element={
            <PrivateRoute
              roles={["admin", "dokter", "perawat"]}
              component={ContainerPage}
            />
          }
        >
          <Route
            path="/"
            element={
              <PrivateRoute
                roles={["admin", "dokter", "perawat"]}
                component={Dashboard}
              />
            }
          />
          <Route
            path="data-obat"
            element={
              <PrivateRoute roles={["admin", "perawat"]} component={Medicine} />
            }
          />
          <Route
            path="request-obat"
            element={
              <PrivateRoute roles={["perawat"]} component={RequestMedicine} />
            }
          />
          <Route
            path="rekam-medis"
            element={<PrivateRoute roles={["dokter"]} component={RekamMedis} />}
          />
          <Route
            path="body-composition"
            element={<PrivateRoute roles={["dokter"]} component={BodyComposition} />}
          />
          <Route
            path="swab"
            element={<PrivateRoute roles={["dokter"]} component={Swab} />}
          />
        </Route>
        <Route path="*" element={<NotFound />} />
        <Route path="/permission-denied" element={<PermissionDenied />} />
      </Routes>
    </Router>
  );
}
